<template>
  <div class="services">
    <h2 class="h4">Derzeit besonders beliebt</h2>
    <a
      v-for="(service, index) in $options.services"
      :key="index"
      class="services__section"
      target="_blank"
      :href="service.link"
    >
      <img :src="require(`@/assets/images/${service.image}`)" alt="" aria-hidden="true" />
      <div class="services__section__right">
        <div class="services__section__right__inner">
          <div>
            <p>{{ service.title }}</p>
            <p>{{ service.subtitle }}</p>
          </div>
          <IconChevronRight aria-hidden="true" />
        </div>
        <hr v-if="index !== $options.services.length - 1" />
      </div>
    </a>
  </div>
</template>

<script>
import IconChevronRight from '@/components/icons/IconChevronRight.vue';

export default {
  components: { IconChevronRight },
  services: [
    // static
    {
      image: 'service-pickerluberprufung.jpg',
      title: 'Pickerlüberprüfung',
      subtitle: 'Objektive, kompetente und rasche Abwicklung der §57a-Begutachtung',
      link: 'https://www.oeamtc.at/mitgliedschaft/pruefdienst-leistungen/57a-begutachtung-pickerl/',
    },
    {
      image: 'service-fahrwerksuberprufung.jpg',
      title: 'Fahrwerksüberprüfung',
      subtitle: 'Reifenschonend und ökonomisch unterwegs, dank einem überprüften Fahrgestell',
      link: 'https://www.oeamtc.at/mitgliedschaft/pruefdienst-leistungen/fahrwerks-ueberpruefung/',
    },
    {
      image: 'service-kaufuberprufung.jpg',
      title: 'Kaufüberprüfung',
      subtitle: 'Für ein sicheres Gefühl beim Kauf und Verkauf eines Kraftfahrzeugs',
      link: 'https://www.oeamtc.at/mitgliedschaft/pruefdienst-leistungen/kauf-ueberpruefung/',
    },
  ],
}
</script>

<style lang="scss">
.services {
  h4 {
    margin-bottom: 16px;
  }

  &__section {
    display: flex;
    margin: 0 -8px;
    padding: 0 8px;

    &:hover {
      background-color: rgba($color-grey-light, 0.3);
      border-radius: 4px;
      cursor: pointer;
    }

    img {
      border-radius: 4px;
      margin: 12px 16px 12px 0;
      height: 64px;
      width: 84px;
    }

    &__right {
      width: 100%;

      &__inner {
        @include flex-center-align;
        justify-content: space-between;
        height: 100%;

        div {
          margin: 16px 0;
          width: 100%;
        }

        p:first-of-type {
          font-weight: $font-weight-bold;
        }

        p:last-of-type {
          color: $color-text-secondary;
        }
      }
    }
  }
}
</style>
